<template>
	<div class="flex justify-between">
		<div class="flex flex-direction margin-lr-xl">
			<RealTimeAlarm></RealTimeAlarm>
			<videoBox/>
			<div>
				<EquipmentFailure></EquipmentFailure>
			</div>
			<div class="flex justify-between">
				<RealTimeAlarmList></RealTimeAlarmList>
				<DayAlarm></DayAlarm>
			</div>
		</div>
		<div class="operaBoxRight">
			<BigTitle :bigtitle="bigtitle"></BigTitle>
			<WarningRankingList></WarningRankingList>
			<WarningEventLine></WarningEventLine>
			<AlertType></AlertType>
		</div>
	</div>
</template>

<script>
import RealTimeAlarm from "@/components/common/realTimeAlarm";
import RealTimeAlarmList from "@/components/common/realTimeAlarmList";
import DayAlarm from "@/components/common/dayAlarm.vue";
// 设备故障
import EquipmentFailure from "@/components/common/equipmentFailure.vue";
// 预警类型分布
import AlertType from "@/components/common/alertType.vue";
// 预警事件趋势
import WarningEventLine from "@/components/common/warningEventLine.vue";
// 头部
import BigTitle from '../bigTitle';
// 城市预警排名
import WarningRankingList from "@/components/common/warningRankingList.vue";
//视频监控
import videoBox from "@/components/common/videoBox.vue";

import { indexRight } from '@/api/indexRight';
import './imouplayer.js'
export default {
  data () {
    return {
			options: {},
			bigtitle:{
				CHN:'告警分析',
				ENG:'Alarm  Analysis'
			},
    };
  },
  components: {
	BigTitle,
	RealTimeAlarm,
	RealTimeAlarmList,
	DayAlarm,
	EquipmentFailure,
	AlertType,
	WarningEventLine,
	WarningRankingList,
	videoBox
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
		
  },
	methods: {
		
	},
	mounted () {

	}
}
</script>
<style lang="scss" scoped>

</style>
